module.exports = "0x38C15Cb29D8Cf6CD6f0261aDdea2B18865681a46"


// WEBPACK FOOTER //
// ./src/contracts/Artists.3.address.js